import {newAxios} from './index'

export const Req_UploadFile = function(data) {
  return newAxios({
    url: '/basic/oss/upload',
    data
  },'multipart')()
}

export const Req_DownloadFile = function(data) {
  return newAxios({
    url: `/i/basic/oss/url/upload`,
    data
  })()
}

//获取oss js-sdk配置
export const Req_GetOssConfig = function (data){
  return newAxios({
    url:`/i/basic/oss/config`,
    data
  })()
}


// WEBPACK FOOTER //
// ./src/request/upload.js